import { Timestamp } from '@@api/generated/google/protobuf/timestamp';

export const formatDateToHHMM = (date: Date): string => {
  return date.toTimeString().split(' ')[0].slice(0, 5);
};

export const formatTimeStampToDate = (timeStamp: Timestamp | undefined) =>
  timeStamp ? Timestamp.toDate(timeStamp) : undefined;
